<div class="sharesHeaders__site">
  <div class="userChip">
    <img class="userAvatar" [src]="userAvatarSrc" alt="User avatar image" />

    <span class="userName" ppTooltip [ppTrimTooltip]="true" [ppTitle]="userName">{{
      userName
    }}</span>
  </div>
</div>
